import { ISearchBoxStyles } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { SearchBox } from "../../../src/taskpane/components/directoryComponents/SearchBox/SearchBox";

const searchBoxStyles: Partial<ISearchBoxStyles> = {
  root: { width: 300, height: "100%" }
};

const QuickFilterBox = React.memo(({
  onApplyFilter
}: {
  onApplyFilter: (val: string | null) => void
}) => {
  const languageStrings = React.useContext(LanguageContext);

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);
  const currentDirectory = useSelector((state: RootState) =>
    state.workingDirectories.workingDirectories.length > 0
      ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1]
      : null
  );

  const [localValue, setLocalValue] = React.useState<string>();

  React.useEffect(() => {
    onClear();
  }, [currentDirectory, searchValue]);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      onApplyFilter(localValue?.trim() || null);
    }, 500);
    return () => clearTimeout(handler);
  }, [localValue, onApplyFilter]);

  const onChange = React.useCallback((_, newValue?: string) => setLocalValue(newValue || ""), []);
  const onSearch = React.useCallback((val: any) => onApplyFilter(val?.trim()), [onApplyFilter]);
  const onClear = React.useCallback(() => {
    setLocalValue("");
    onApplyFilter(null);
  }, [onApplyFilter]);

  return (
    <SearchBox
      styles={searchBoxStyles}
      placeholder={languageStrings.FilterResults}
      underlined={true}
      value={localValue}
      onChange={onChange}
      onSearch={onSearch}
      onClear={onClear}
      showIcon={true}
    />
  );
});

export const useMenuItem_QuickFilter = (setQuickFilterValue: (filterValue: string | null) => void) => {
  const enableQuickFilter = useSelector((state: RootState) => state.tenantInfo?.enableQuickFilter);

  const onMenuItem_QuickFilterRender = React.useCallback(() => {
    return <QuickFilterBox onApplyFilter={(v) => setQuickFilterValue(v)} />;
  }, []);

  const menuItem_QuickFilter = React.useMemo(() => {
    if (!enableQuickFilter) {
      return null;
    }

    return {
      key: "QuickFilter",
      onRender: onMenuItem_QuickFilterRender
    }
  }, [onMenuItem_QuickFilterRender]);

  const resetQuickFilterValue = React.useCallback(() => {
    setQuickFilterValue(null);
  }, [setQuickFilterValue]);

  return {
    menuItem_QuickFilter,
    resetQuickFilterValue
  };
};